export const openWhatsApp = ({ phone, message = '' }) => {
  const cleanPhone = (phone || '').replace(/[^0-9]/g, '')
  if (!cleanPhone) return

  const encodedText = encodeURIComponent(message)

  const appUrl = `whatsapp://send?phone=${cleanPhone}&text=${encodedText}`
  const webUrl = `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedText}`

  let hasApp = false

  const handleBlur = () => {
    hasApp = true
    window.removeEventListener('blur', handleBlur)
  }

  window.addEventListener('blur', handleBlur)

  window.location.href = appUrl

  // Open to web if not open app in desktop
  setTimeout(() => {
    window.removeEventListener('blur', handleBlur)
    if (!hasApp && document.hasFocus()) {
      window.open(webUrl, '_blank', 'noopener,noreferrer')
    }
  }, 1500)
}
